'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = require('ramda');

var MONO_FONT = 'Menlo, Monaco, Consolas, "Lucida Console", monospace';
var SERIF_FONT = '"Lucida Grande", Helvetica, arial, sans-serif';

var styles = {
  metaWrap: function metaWrap(_ref) {
    var fullWidth = _ref.fullWidth;

    return {
      padding: fullWidth ? '0 10px' : 0
    };
  },
  location: {
    fontSize: 18,
    fontFamily: SERIF_FONT,
    color: '#aaa',
    marginBottom: 10
  },
  locationItem: function locationItem(_ref2) {
    var last = _ref2.last;

    return {
      color: last ? '#000' : 'inerit'
    };
  },
  locationDel: {
    margin: '0 .2em',
    color: '#aaa'
  },
  'import': {
    fontFamily: MONO_FONT,
    fontSize: 14,
    marginBottom: 10,
    color: '#aaa',
    float: 'right'
  },
  description: {
    maxWidth: 600,
    marginBottom: 10,
    fontFamily: SERIF_FONT,
    fontSize: 14
  },
  files: function files(_ref3) {
    var fullWidth = _ref3.fullWidth;

    return {
      margin: fullWidth ? '20px 10px' : '20px 0'
    };
  },
  fileName: {
    fontFamily: SERIF_FONT,
    fontSize: 14,
    fontWeight: 'bold'
  },
  fileContnet: {
    fontFamily: MONO_FONT,
    fontSize: 11,
    margin: '5px 0 20px 0',
    background: '#d7e5ec',
    padding: 5,
    borderRadius: 3,
    overflow: 'auto'
  }
};

function locationItem(name, i, _ref4) {
  var length = _ref4.length;

  var last = length === i + 1;
  return [_react2['default'].createElement(
    'span',
    { key: i + 'item', style: styles.locationItem({ last: last }) },
    name
  ), !last && _react2['default'].createElement(
    'span',
    { key: i + 'del', style: styles.locationDel },
    '/'
  )];
}

exports['default'] = _createReactClass2['default']({

  propTypes: {
    demo: _propTypes2['default'].node,
    fullWidth: _propTypes2['default'].bool,
    location: _propTypes2['default'].array.isRequired,
    importPath: _propTypes2['default'].string,
    name: _propTypes2['default'].string,
    description: _propTypes2['default'].node,
    files: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({ name: _propTypes2['default'].string.isRequired, content: _propTypes2['default'].string.isRequired }).isRequired)
  },

  renderFile: function renderFile(file, index) {
    return _react2['default'].createElement(
      'div',
      { key: index },
      _react2['default'].createElement(
        'div',
        { style: styles.fileName },
        file.name
      ),
      _react2['default'].createElement(
        'pre',
        { style: styles.fileContnet },
        file.content
      )
    );
  },

  render: function render() {
    var _props = this.props;
    var demo = _props.demo;
    var fullWidth = _props.fullWidth;
    var location = _props.location;
    var importPath = _props.importPath;
    var description = _props.description;
    var files = _props.files;
    var _props$name = _props.name;
    var name = _props$name === undefined ? _ramda.last(location) : _props$name;

    return _react2['default'].createElement(
      'div',
      null,
      _react2['default'].createElement(
        'div',
        { style: styles.metaWrap({ fullWidth: fullWidth }) },
        _react2['default'].createElement(
          'div',
          { style: styles['import'] },
          'import ',
          name,
          ' from \'',
          importPath,
          '\''
        ),
        _react2['default'].createElement(
          'div',
          { style: styles.location },
          _ramda.unnest(location.map(locationItem))
        ),
        _react2['default'].createElement(
          'div',
          { style: styles.description },
          description
        )
      ),
      _react2['default'].createElement(
        'div',
        null,
        demo
      ),
      files && _react2['default'].createElement(
        'div',
        { style: styles.files({ fullWidth: fullWidth }) },
        files.map(this.renderFile)
      )
    );
  }

});
module.exports = exports['default'];